import { DateInput as MantineDateInput } from '@mantine/dates';
import React from 'react';
import { JiraFieldData2 } from '../../../../api/endpoints/jira';

interface DateInputProps {
    field: JiraFieldData2;
    value: Date | null;
    error?: boolean;
    onChange: (value: Date | null) => void;
    onSubmit: (value: Date | null) => void;
}

export const JiraDateInput = React.memo(({ field, value, error, onChange, onSubmit }: DateInputProps) => {
    // Handle the conversion between string and Date for Mantine DateInput
    const handleChange = (val: string | null) => {
        if (val === null) {
            onChange(null);
            onSubmit(null);
        }
        else {
            onChange(new Date(val));
            onSubmit(new Date(val));
        }
    };

    return (
        <MantineDateInput
            label={field.name}
            placeholder={`Select ${field.name.toLowerCase()}`}
            required={field.required && !field.hasDefaultValue}
            value={value}
            onChange={handleChange}
            clearable={!field.required}
            error={error}
        />
    );
});
